export const GroupType = {
  Individual: 0,
  Group: 1,
} as const
export type GroupType = (typeof GroupType)[keyof typeof GroupType]

export type MarketSegmentType = {
  id: string
  code: string
  name: string
  groupType: GroupType
}
